import { styled } from '@mui/material/styles'
import { TextField, Typography } from '@mui/material'

export const TextFieldStyled = styled(TextField)({
  display: 'block',
  width: '100%',
  marginBottom: 20,
})

export const LogoWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
})

export const Image = styled('img')({
  display: 'flex',
  objectFit: 'cover',
  width: 90,
  maxHeight: 80,
})

export const ImageName = styled(Typography)({
  display: 'flex',
})

export const IconWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: 8,
  color: theme.palette.text.secondary,
}))

export const ImageWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px dotted',
  width: '100%',
  height: 120,
})
